import React from "react";
import { Routes, Route, useParams, useLocation } from "react-router-dom";
import BoardListPage from "./BoardListPage";
import BoardPage from "./BoardPage";
import TasksInboxPage from "./TasksInboxPage";
import TeamWorkspaceLayout from "../Team/components/TeamWorkspaceLayout";
import { getTasksBasePath, TEAM_BASE } from "../../utils/teamNavigation";

const BoardPageRoute = ({ standalone, backPath }) => {
  const { boardId } = useParams();
  return (
    <BoardPage
      boardId={Number(boardId)}
      standalone={standalone}
      backPath={backPath}
    />
  );
};

const BoardLeadRoute = ({ standalone, backPath }) => {
  const { leadId } = useParams();
  return (
    <BoardPage
      leadId={Number(leadId)}
      standalone={standalone}
      backPath={backPath || "/chat"}
    />
  );
};

const BoardSpaceRoute = ({ standalone, backPath, tasksBase }) => {
  const { spaceId } = useParams();
  return (
    <BoardPage
      spaceId={Number(spaceId)}
      standalone={standalone}
      backPath={backPath || tasksBase}
    />
  );
};

function resolveTasksActiveSection(pathname, tasksBase) {
  const base = tasksBase.replace(/\/+$/, "");
  if (pathname.includes(`${base}/inbox`)) return "inbox";
  return "tasks";
}

const TeamTasksRoutes = ({ basePath = TEAM_BASE, standalone = false }) => {
  const location = useLocation();
  const tasksBase = getTasksBasePath(basePath);
  const activeSection = resolveTasksActiveSection(location.pathname, tasksBase);
  const normalizedPath = location.pathname.replace(/\/+$/, "");
  const normalizedBase = tasksBase.replace(/\/+$/, "");
  const contentScroll =
    normalizedPath === normalizedBase || normalizedPath === `${normalizedBase}/inbox`;

  return (
    <TeamWorkspaceLayout
      basePath={basePath}
      activeSection={activeSection}
      contentScroll={contentScroll}
      standalone={standalone}
    >
      <Routes>
        <Route index element={<BoardListPage standalone={standalone} basePath={tasksBase} />} />
        <Route path="inbox" element={<TasksInboxPage standalone={standalone} basePath={tasksBase} />} />
        <Route
          path="lead/:leadId"
          element={<BoardLeadRoute standalone={standalone} backPath="/chat" />}
        />
        <Route
          path="space/:spaceId"
          element={
            <BoardSpaceRoute standalone={standalone} backPath={tasksBase} tasksBase={tasksBase} />
          }
        />
        <Route
          path=":boardId"
          element={<BoardPageRoute standalone={standalone} backPath={tasksBase} />}
        />
      </Routes>
    </TeamWorkspaceLayout>
  );
};

export default TeamTasksRoutes;
